import React, { useEffect, useState } from 'react';

export function HelpTableOfContents({ sections }) {
  const [active, setActive] = useState(sections[0]?.id || '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sections]);

  return (
    <nav className="space-y-1" aria-label="Table of contents">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">On this page</p>
      {sections.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className={`block text-sm py-1 px-2 rounded transition-colors ${
            active === id
              ? 'text-orange-600 font-medium bg-orange-50'
              : 'text-slate-500 hover:text-slate-900'
          }`}
          onClick={(e) => {
            e.preventDefault();
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          {label}
        </a>
      ))}
    </nav>
  );
}
